<div>
    <!--<div class="alert alert-warning">
        <div *ngIf="SelectedUser">{{SelectedUser.firstName}} {{SelectedUser.lastName}}</div>
    </div>-->

        <form class="example-form" [formGroup]='UserSearchForm'>

            <ng-container *ngIf="!ShowLabelFloating">
                <div><b>Select User</b></div>
                <div *ngIf="SelectedUser">
                    <button class="btn btn-secondary" (click)="OnSelectedUserClicked()">{{SelectedUser.firstName}} {{SelectedUser.lastName}}</button>
                    <span>&nbsp;&nbsp;&nbsp;<a (click)="OnClearSelection()" class="subtleLink">Clear</a></span>
                </div>
                <div *ngIf="ShowSearch">
                    <mat-form-field class="example-full-width"  appearance="outline" >
                        <input matInput placeholder="[Enter a Name]" [matAutocomplete]="auto" formControlName='userInput'>
                    </mat-form-field>

                    <mat-autocomplete #auto="matAutocomplete"  [displayWith]="displayFn" (optionSelected)="OnUserSelected($event.option.value)">
                        <mat-option *ngIf="IsLoading$ | async"><lgv-loading-indicator [CSSClass]="'Small'"></lgv-loading-indicator></mat-option>
                        <ng-container *ngIf="!(IsLoading | async)">
                            <mat-option *ngFor="let u of (FilteredUsers$ | async)" [value]="u">
                                {{ u.firstName }} {{ u.lastName }} | <small>{{u.email}}</small>
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete>
                </div>
            </ng-container>



            <ng-container *ngIf="ShowLabelFloating">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{Label}}</mat-label>
                    <input matInput [placeholder]="'Select ' + Label" [matAutocomplete]="auto" formControlName="userInput">
                    <mat-error *ngIf="UserSearchForm.controls.userInput.errors?.required">{{Label}} is Required</mat-error>
                </mat-form-field>
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayUser" (optionSelected)="OnUserSelected($event.option.value)">
                    <mat-option *ngIf="IsLoading$ | async">
                        <lgv-loading-indicator [CSSClass]="'Small'"></lgv-loading-indicator>
                    </mat-option>
                    <ng-container *ngIf="(IsLoading$ | async) === false">
                        <mat-option *ngFor=" let x of FilteredUsers$ | async " [value]="x"
                            title="{{x.firstName}} - {{x.lastName}}">
                            {{x.firstName}} {{x.lastName}}
                        </mat-option>
                    </ng-container>
                </mat-autocomplete>
            </ng-container>



        </form>
</div>
